(() => { 
  // console.log("BTU CALC: script loaded1");
  const root = document.getElementById("btu-calc-root");
if (!root) return;
// console.log("ATTR coupler small:", root.getAttribute("data-coupler-small"));
// console.log("ATTR coupler large:", root.getAttribute("data-coupler-large"));
// console.log("DATASET keys:", Object.keys(root.dataset));
// console.log("DATASET couplerSmall:", root.dataset.couplerSmall);
// console.log("DATASET couplerLarge:", root.dataset.couplerLarge);
root.innerHTML = `
  <style>
    #btu-calc {
      max-width: 1100px;
      margin: 40px auto;
      padding: 16px;
      font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
      box-sizing: border-box;
    }

    #btu-calc, #btu-calc * {
      box-sizing: border-box;
    }

    .btu-main-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }

    .btu-card {
      border: 1px solid #e5e5e5;
      border-radius: 12px;
      padding: 16px;
      box-shadow: 0 6px 18px rgba(0, 0, 0, .06);
      min-width: 0;
    }

    .btu-top-row {
      display: flex;
      gap: 12px;
      align-items: center;
      margin-bottom: 12px;
    }

    .btu-single-grid,
    .btu-room-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 10px;
    }

    .btu-room-grid-2 {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 10px;
      margin-top: 10px;
    }

    .btu-single-cards {
      margin-top: 14px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }

    .btu-len-row {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .btu-action-row {
      display: flex;
      gap: 10px;
      margin-top: 12px;
      flex-wrap: wrap;
    }

    .btu-field {
      display: flex;
      flex-direction: column;
      gap: 6px;
      min-width: 0;
    }

    .btu-field input,
    .btu-field select,
    .btu-len-row select,
    .btu-len-row button,
    .btu-action-row button,
    #addBundle {
      width: 100%;
      min-width: 0;
    }

    #capWrap {
      width: 180px;
    }

    @media (max-width: 900px) {
      .btu-main-grid,
      .btu-single-cards {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 640px) {
      #btu-calc {
        margin: 20px auto;
        padding: 12px;
      }

      #btu-calc h2 {
        font-size: 24px !important;
        line-height: 1.2;
      }

      .btu-top-row {
        flex-direction: column;
        align-items: stretch;
      }

      #capWrap {
        width: 100% !important;
      }

      .btu-single-grid,
      .btu-room-grid,
      .btu-room-grid-2 {
        grid-template-columns: 1fr;
      }

      .btu-len-row {
        flex-direction: column;
        align-items: stretch;
      }

      #totalBtu {
        font-size: 32px;
      }

      .btu-result-big {
        font-size: 32px !important;
        line-height: 1.1;
      }

      .btu-pill {
        font-size: 14px !important;
      }

      .btu-action-row {
        flex-direction: column;
      }
    }
  </style>

  <div id="btu-calc">
    <h2 style="margin:0 0 12px; color: rgb(47, 3, 96);">Single/Multi-Zone Builder</h2>
    <p style="margin:0 0 20px;color:#555;">Rule-of-thumb sizing (not a Manual J). Includes ceiling height adjustment.</p>

    <div class="btu-main-grid">
      <!-- LEFT: INPUTS -->
      <div class="btu-card">
        <div class="btu-top-row">
          <label class="btu-field" style="flex:1;">
            <span style="font-size:12px;color:#666;">Mode</span>
            <select id="mode" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
              <option value="single">Single room</option>
              <option value="multi">Multi-zone</option>
            </select>
          </label>

          <label id="capWrap" class="btu-field" style="display:none; box-shadow: 0 6px 18px rgba(0, 0, 0, .06);">
            <span style="font-size:12px;color:#666;">Max rooms (cap)</span>
            <select id="cap" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4" selected>4</option>
              <option value="5">5</option>
              <option value="6">6</option>
            </select>
          </label>
        </div>

        <!-- SINGLE -->
        <div id="singleUI" style="display:block;">
          <h3 style="margin:8px 0 12px;font-size:16px;">Room details</h3>
          <div class="btu-single-grid">
            <label class="btu-field">
              <span style="font-size:12px;color:#666;">Length (ft)</span>
              <input id="sLen" type="number" min="0" step="0.5" value="15" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
            </label>
            <label class="btu-field">
              <span style="font-size:12px;color:#666;">Width (ft)</span>
              <input id="sWid" type="number" min="0" step="0.5" value="12" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
            </label>
            <label class="btu-field">
              <span style="font-size:12px;color:#666;">Ceiling height (ft)</span>
              <input id="sHei" type="number" min="7" max="20" step="0.5" value="8" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
            </label>
          </div>
        </div>

        <!-- MULTI -->
        <div id="multiUI" style="display:none;">
          <h3 style="margin:8px 0 12px;font-size:16px;">Rooms (up to 6)</h3>
          <div id="rooms"></div>

          <div class="btu-action-row">
            <button id="addRoom" style="padding:10px 14px;border-radius:10px;border:1px solid #ddd;background:white;cursor:pointer;font-weight:600;">+ Add room</button>
            <button id="reset" style="padding:10px 14px;border-radius:10px;border:1px solid #ddd;background:white;cursor:pointer;">Reset</button>
          </div>

          <div style="margin-top:8px;font-size:12px;color:#666;">
            Sizing is oversize-biased. Ceiling height increases effective sqft: <code>sqft * (height / 8)</code>.
          </div>
        </div>
      </div>

      <!-- RIGHT: RESULTS -->
      <div class="btu-card">
        <div class="btu-pill" style="display:inline-block;background:#1695f2;color:white;padding:6px 16px;border-radius:999px;font-weight:700;font-size:16px;margin-bottom:10px;">Results</div>

        <div class="btu-result-big" style="font-size:40px;font-weight:800;line-height:1;margin-bottom:6px;">
          <span id="totalBtu">—</span><span style="font-size:18px;font-weight:700;"> BTU/h</span>
        </div>
        <div style="color:#666;margin-bottom:12px;">
          <span id="totalKw">—</span> kW
        </div>

        <div id="roomSummary" style="margin:8px 0 12px;"></div>
        <div id="condSummary" style="margin:10px 0 8px; font-size:13px; color:#111; font-weight:700;"></div>
        <div id="partsList" style="margin:6px 0 12px;"></div>

        <div id="singleCards" class="btu-single-cards">
          <div style="border:1px solid #eee;border-radius:12px;padding:12px;">
            <div style="font-weight:600;margin-bottom:8px;">5th Gen (Best)</div>
            <div style="font-size:13px;color:#555;margin-bottom:10px;">
              Recommended: <span id="bestRec">—</span>
            </div>
            <div class="btu-len-row">
              <select id="bestLen" style="padding:10px;border-radius:10px;border:1px solid #ddd; flex:1;"></select>
              <button id="bestAdd" style="padding:10px 14px;border-radius:999px;border:0;background:#1695f2;color:white;font-weight:600;cursor:pointer; width: unset;">Add to cart</button>
            </div>
            <div id="bestMsg" style="margin-top:8px;font-size:12px;color:#666;"></div>
          </div>

          <div style="border:1px solid #eee;border-radius:12px;padding:12px;">
            <div style="font-weight:600;margin-bottom:8px;">EZPRO (Budget Friendly)</div>
            <div id="ezRecRow" style="font-size:13px;color:#555;margin-bottom:10px;">
              Recommended: <span id="ezRec">—</span>
            </div>
            <div class="btu-len-row">
              <select id="ezLen" style="padding:10px;border-radius:10px;border:1px solid #ddd; flex:1;"></select>
              <button id="ezAdd" style="padding:10px 14px;border-radius:999px;border:0;background:#1695f2;color:white;font-weight:600;cursor:pointer; width: unset;">Add to cart</button>
            </div>
            <div id="ezMsg" style="margin-top:8px;font-size:12px;color:#666;"></div>
          </div>
        </div>

        <button id="addBundle" style="margin-top:12px;width:100%;padding:10px 14px;border-radius:999px;border:0;background:#2f0360;color:#ffffff;font-weight:800;cursor:pointer;display:none;">
          Add full bundle to cart
        </button>

        <div id="bundleMsg" style="margin-top:10px;font-size:12px;color:#666;"></div>
      </div>
    </div>
  </div>
`;


/**
 * ============================
 * CONFIG — HANDLES
 * ============================
 */
const CONFIG = {
  handles: {
    // MULTI-ZONE
    multiCondenser: root.dataset.multiCondenserHandle,  
    wallAhu: root.dataset.wallAhuHandle,                
    cassetteAhu: root.dataset.cassetteAhuHandle,     
    lineSetsByGauge: {
      "1438": root.dataset.linesetSmall,
      "1412": root.dataset.linesetMedium,
      "3858": root.dataset.linesetLarge
    },
    // EXTENSIONS FOR EZPRO
    easyProLineset16Small: root.getAttribute("data-easypro-lineset-small") || root.dataset.easyproLinesetSmall,
    easyProLineset16Medium: root.getAttribute("data-easypro-lineset-medium") || root.dataset.easyproLinesetMedium,
    easyProLineset16Large: root.getAttribute("data-easypro-lineset-large") || root.dataset.easyproLinesetLarge, 
    // SINGLE ROOM
    singleBest: root.dataset.singleBestHandle,         
    singleEzpro: root.dataset.singleEzproHandle,         
    coupler75Small: root.getAttribute("data-coupler-small") || root.dataset.couplerSmall,
    coupler75Large: root.getAttribute("data-coupler-large") || root.dataset.couplerLarge,
  },



  // Oversize bias
  bias: 0.90,
  // Hard ceiling: 36k max coverage
  maxEffSqft: 1550,
  // Sizing bands (sqft upper limits at 8ft baseline)
  singleBands: [
    { max: 225, btu: 9000 },
    { max: 350, btu: 12000 },
    { max: 500, btu: 18000 },
    { max: 750, btu: 24000 },
    { max: 1000, btu: 36000 }
  ],
  multiBands: [
    { max: 225, btu: 6000 },
    { max: 350, btu: 9000 },
    { max: 500, btu: 12000 },
    { max: 750, btu: 18000 },
    { max: 1000, btu: 24000 },
    { max: 1500, btu: 36000 }
  ],

  // Head size -> line gauge key
  gaugeKeyByBtu: {
    6000: "1438",
    9000: "1438",
    12000:"1438",
    18000:"1412",
    24000:"3858",
    36000:"3858"
  },

  // Default line length in multi-room
  defaultLineLen: 16,

  // Add this “safe allowance” for condenser selection
  condenserAllowance: 6000
};
// console.log("EZ Small:", CONFIG.handles.easyProLineset16Small);
// console.log("EZ Medium:", CONFIG.handles.easyProLineset16Medium);
// console.log("EZ Large:", CONFIG.handles.easyProLineset16Large);

// console.log(Object.keys(root.dataset));
// ---------- Helpers: Shopify endpoints ----------
const cache = new Map();

async function fetchProduct(handle) {
  if (!handle) throw new Error("Missing product handle");
  if (cache.has(handle)) return cache.get(handle);
  const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
  if (!res.ok) throw new Error(`Failed to fetch product ${handle}.js`);
  const json = await res.json();
  cache.set(handle, json);
  return json;
}

function getIncludedLineLen(series) {
  return series === "best" ? 25 : 16;
}

async function getCartJSON() {
  const res = await fetch("/cart.js", { credentials: "same-origin" });
  if (!res.ok) throw new Error("Failed to fetch /cart.js");
  return await res.json();
}
function getCartCountBubbleEl() {
  return (
    document.querySelector("#cart-icon-bubble .cart-count-bubble") ||
    document.querySelector(".header__icon--cart .cart-count-bubble") ||
    document.querySelector(".cart-count")
  );
}

function updateCartBubbleCount(count) {
  const bubble = getCartCountBubbleEl();
  if (!bubble) return;

  const num =
    bubble.querySelector('[aria-hidden="true"]') ||
    bubble.querySelector("span") ||
    bubble;

  if (num) num.textContent = String(count);

  const sr = bubble.querySelector(".visually-hidden");
  if (sr) sr.textContent = `Cart (${count} items)`;

  if (count > 0) {
    bubble.classList.remove("hidden");
    bubble.removeAttribute("aria-hidden");
  } else {
    bubble.classList.add("hidden");
    bubble.setAttribute("aria-hidden", "true");
  }
}

async function cartChangeLine(line, quantity) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ line, quantity })
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.description || "Cart change failed");
  return json;
}

function closeCartDrawer() {
  const drawerEl = document.querySelector("cart-drawer");
  if (drawerEl) {
    if (typeof drawerEl.close === "function") {
      drawerEl.close();
      return;
    }
    drawerEl.removeAttribute("open");
    drawerEl.classList.remove("active", "is-open");
  }

  // CartDrawer container
  const container =
    document.getElementById("CartDrawer") ||
    document.querySelector("#CartDrawer.drawer") ||
    document.querySelector(".drawer--cart");

  if (container) {
    container.classList.remove("active", "is-open");
    container.setAttribute("aria-hidden", "true");
  }

  document.body.classList.remove("overflow-hidden");
}

async function refreshCartSections() {
  const sectionIds = ["cart-drawer", "cart-icon-bubble"];
  const rootPath = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
  const url = `${rootPath}?sections=${encodeURIComponent(sectionIds.join(","))}`;

  const res = await fetch(url, {
    credentials: "same-origin",
    headers: { Accept: "application/json" }
  });

  const text = await res.text();
  if (text.trim().startsWith("<")) return null;

  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

function setInnerHTMLFromSection(sectionHTML, selector) {
  const doc = new DOMParser().parseFromString(sectionHTML, "text/html");
  const fresh = doc.querySelector(selector);
  const current = document.querySelector(selector);
  if (!fresh || !current) return false;
  current.innerHTML = fresh.innerHTML; // 👈 keep the same outer element; only swap contents
  return true;
}

async function openCartDrawer() {
  const drawerEl = document.querySelector("cart-drawer");
  if (drawerEl) {
    if (typeof drawerEl.open === "function") drawerEl.open();
    else {
      drawerEl.setAttribute("open", "");
      drawerEl.classList.add("active", "is-open");
    }
    document.body.classList.add("overflow-hidden");
    return true;
  }

  const openBtn =
    document.querySelector('button[aria-controls="CartDrawer"]') ||
    document.querySelector('[aria-controls="CartDrawer"]');

  if (openBtn) {
    openBtn.click();
    return true;
  }

  return false;
}

async function openAndRefreshCartDrawer() {
  const sections = await refreshCartSections();

  if (sections?.["cart-icon-bubble"]) {
    setInnerHTMLFromSection(sections["cart-icon-bubble"], "#cart-icon-bubble") ||
      setInnerHTMLFromSection(sections["cart-icon-bubble"], ".header__icon--cart");
  }

  if (sections?.["cart-drawer"]) {
    setInnerHTMLFromSection(sections["cart-drawer"], "cart-drawer") ||
      setInnerHTMLFromSection(sections["cart-drawer"], "#CartDrawer") ||
      setInnerHTMLFromSection(sections["cart-drawer"], ".drawer--cart");
  }

  const cart = await getCartJSON();
  updateCartBubbleCount(cart.item_count || 0);

  await openCartDrawer();
}

async function addToCart(items) {
  const res = await fetch(`/cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ items })
  });

  const json = await res.json();
  if (!res.ok) throw new Error(json?.description || "Cart add failed");

  await openAndRefreshCartDrawer();

  return json;
}
function getAllowedHeadSizes(type) {
  const all = [6000, 9000, 12000, 18000, 24000, 36000];
  if (type === "cassette") {
    return all.filter(btu => btu !== 24000 && btu !== 36000);
  }
  return all;
}

function normalizeHeadSizeForType(type, btu) {
  const allowed = getAllowedHeadSizes(type);
  if (allowed.includes(Number(btu))) return Number(btu);

  // If invalid for this type, fall back to the largest allowed size
  return allowed[allowed.length - 1];
}
function btuToKw(btu) {
  return (btu * 0.000293071).toFixed(2);
}

function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

function effectiveSqft(len, wid, heightFt) {
  const sf = (Number(len) || 0) * (Number(wid) || 0);
  const h = clamp(Number(heightFt) || 8, 7, 20);
  return sf * (h / 8);
}

function sizeByBands(effSqft, bands, bias) {
  // Oversize bias
  for (const band of bands) {
    if (effSqft <= band.max * bias) return band.btu;
  }
  return bands[bands.length - 1].btu;
}

// ---------- Variant resolving  ----------
function includesAny(str, arr) {
  const s = (str || "").toLowerCase();
  return arr.some(x => s.includes(String(x).toLowerCase()));
}

function findVariantByTexts(product, mustIncludeTexts) {
  const vars = product?.variants || [];
  return vars.find(v => includesAny(v.title, mustIncludeTexts) || includesAny(v.option1, mustIncludeTexts) || includesAny(v.option2, mustIncludeTexts) || includesAny(v.option3, mustIncludeTexts));
}

function extractFtFromTitle(title) {
  const m = String(title || "").match(/(\d+)\s*(?:ft|')/i);
  return m ? Number(m[1]) : null;
}

function uniqSorted(nums) {
  return [...new Set(nums)].filter(n => Number.isFinite(n)).sort((a,b)=>a-b);
}

// ---------- Multi-room data model ----------
let state = {
  mode: "single",
  cap: 4,
  rooms: [
    { label: "Room 1", len: 12, wid: 12, height: 8, type: "wall", size: null, lineLen: CONFIG.defaultLineLen },
    { label: "Room 2", len: 12, wid: 15, height: 8, type: "wall", size: null, lineLen: CONFIG.defaultLineLen }
  ],
  // Single selections
  single: {
    len: 15, wid: 12, height: 8,
    bestLineLen: 25,
    ezLineLen: 16
  }
};

function roomCard(i) {
  const r = state.rooms[i];
  const eff = effectiveSqft(r.len, r.wid, r.height);
  const rawSuggested = sizeByBands(eff, CONFIG.multiBands, CONFIG.bias);
  const suggested = normalizeHeadSizeForType(r.type, rawSuggested);
  const currentSize = normalizeHeadSizeForType(r.type, Number(r.size) || suggested);
  const sf = (Number(r.len) || 0) * (Number(r.wid) || 0);

  return `
  <div style="border:1px solid #eee;border-radius:12px;padding:12px;margin-bottom:10px;">
    <div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;">
      <div style="font-weight:800;">${r.label || `Room ${i+1}`}</div>
      <button data-remove="${i}" style="padding:6px 10px;border-radius:10px;border:1px solid #ddd;background:white;cursor:pointer;">Remove</button>
    </div>

    <div class="btu-room-grid" style="margin-top:10px;">
      <label class="btu-field">
        <span style="font-size:12px;color:#666;">Length (ft)</span>
        <input data-room="${i}" data-k="len" type="number" min="0" step="0.5" value="${r.len}" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
      </label>
      <label class="btu-field">
        <span style="font-size:12px;color:#666;">Width (ft)</span>
        <input data-room="${i}" data-k="wid" type="number" min="0" step="0.5" value="${r.wid}" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
      </label>
      <label class="btu-field">
        <span style="font-size:12px;color:#666;">Ceiling (ft)</span>
        <input data-room="${i}" data-k="height" type="number" min="7" max="20" step="0.5" value="${r.height}" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
      </label>
    </div>

    <div class="btu-room-grid-2">
      <label class="btu-field">
        <span style="font-size:12px;color:#666;">Air handler</span>
        <select data-room="${i}" data-k="type" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
          <option value="wall" ${r.type === "wall" ? "selected" : ""}>Wall mount</option>
          <option value="cassette" ${r.type === "cassette" ? "selected" : ""}>Ceiling cassette</option>
        </select>
      </label>

      <label class="btu-field">
        <span style="font-size:12px;color:#666;">Nominal size</span>
        <select data-room="${i}" data-k="size" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
          ${[6000, 9000, 12000, 18000, 24000, 36000].map(btu => {
            const disabled = r.type === "cassette" && (btu === 24000 || btu === 36000);
            return `
              <option
                value="${btu}"
                ${(currentSize === btu) ? "selected" : ""}
                ${disabled ? "disabled" : ""}
              >
                ${Math.round(btu / 1000)}k${disabled ? " — unavailable for cassette" : ""}
              </option>
            `;
          }).join("")}
        </select>
      </label>

      <label class="btu-field">
        <span style="font-size:12px;color:#666;">Line set length</span>
        <select data-room="${i}" data-k="lineLen" style="padding:10px;border-radius:10px;border:1px solid #ddd;">
          ${[16,25,35,50,66,75].map(ft => `
            <option value="${ft}" ${Number(r.lineLen) === ft ? "selected" : ""}>${ft} ft</option>
          `).join("")}
        </select>
      </label>
    </div>

    <div style="margin-top:10px;font-size:12px;color:#666;">
      Suggested: <strong>${Math.round(suggested / 1000)}k</strong> for ~${Math.round(sf)} sq ft, ${r.height}ft ceilings → <strong>${Math.round(eff)} eq sq ft</strong>
  
    </div>
  </div>`;
}

function renderRooms() {
  const wrap = document.getElementById("rooms");
  wrap.innerHTML = state.rooms.map((_, i) => roomCard(i)).join("");
}

function computeSingleSizing() {
  const eff = effectiveSqft(state.single.len, state.single.wid, state.single.height);

  // Hard limit — no unit available above this effective sqft
  if (eff > CONFIG.maxEffSqft) return null;

  return sizeByBands(eff, CONFIG.singleBands, CONFIG.bias);
}


function computeMultiRoom() {
  const summaries = [];
  let sumHeads = 0;
  let hasOverLimitRoom = false;

  state.rooms.forEach((r, idx) => {
    const eff = effectiveSqft(r.len, r.wid, r.height);

    // hard ceiling per-room (effective sqft)
    const overLimit = eff > CONFIG.maxEffSqft;
    if (overLimit) hasOverLimitRoom = true;

    const suggested = sizeByBands(eff, CONFIG.multiBands, CONFIG.bias);

    // If over limit, no valid chosen size
    const chosen = overLimit ? null : (Number(r.size) || suggested);

    if (chosen) sumHeads += chosen;

    const sf = (Number(r.len) || 0) * (Number(r.wid) || 0);

    summaries.push({
      idx,
      label: r.label || `Room ${idx + 1}`,
      sf: Math.round(sf),
      eff: Math.round(eff),
      overLimit,
      suggested,
      chosen,
      type: r.type,
      lineLen: Number(r.lineLen) || CONFIG.defaultLineLen
    });
  });

  // condenser target + allowance
  const target = sumHeads
  
  const zones = state.rooms.length;

  return { summaries, sumHeads, target, zones, hasOverLimitRoom };
}

function isMoreThanTenPercentOver(sumHeads, condenserBtu) {
  return sumHeads > (condenserBtu * 1.10);
}
function chooseCondenserBtuByHeads(sumHeads) {
  // Match actual catalog sizes — NO 60k

  const bands = [
    { maxHeads: 24000, condenserBtu: 18000 },
    { maxHeads: 33000, condenserBtu: 27000 },
    { maxHeads: 42000, condenserBtu: 36000 },
    { maxHeads: 53000, condenserBtu: 48000 },
    { maxHeads: Infinity, condenserBtu: 55000 } // top size
  ];

  for (const b of bands) {
    if (sumHeads <= b.maxHeads) return b.condenserBtu;
  }

  return 55000;
}

function setBtnDisabled(btn, disabled) {
  if (!btn) return;
  btn.disabled = !!disabled;
  btn.style.opacity = disabled ? "0.5" : "1";
  btn.style.cursor = disabled ? "not-allowed" : "pointer";
}

function renderResults() {
  const mode = state.mode;
  const totalBtuEl = document.getElementById("totalBtu");
  const totalKwEl = document.getElementById("totalKw");
  const roomSummaryEl = document.getElementById("roomSummary");
  const condEl = document.getElementById("condSummary");
  const partsEl = document.getElementById("partsList");
  const addBundleBtn = document.getElementById("addBundle");
  const singleCards = document.getElementById("singleCards");

if (condEl) condEl.textContent = "Single-zone system (handled by product selection below)";
if (partsEl) partsEl.innerHTML = `<div style="color:#666;font-size:13px;">Use “Add to cart” …</div>`;
if (mode === "single") {
  addBundleBtn.style.display = "none";
  if (singleCards) singleCards.style.display = "grid";

  const btu = computeSingleSizing();

  const sf = (Number(state.single.len) || 0) * (Number(state.single.wid) || 0);
  const eff = effectiveSqft(state.single.len, state.single.wid, state.single.height);

 const overLimit = eff > CONFIG.maxEffSqft;

roomSummaryEl.innerHTML = `
  ${overLimit ? `
    <div style="margin:0 0 8px;color:#b00020;font-size:13px;font-weight:700;">
      Max coverage is ${CONFIG.maxEffSqft} sq ft (effective). This room is ~${Math.round(eff)} eq sq ft. Reduce room size or ceiling height adjustment.
    </div>
  ` : ""}

  <div style="padding:10px;border-radius:12px;border:1px solid #eee;background:#fafafa;">
    Room (~${Math.round(sf)} sq ft, ${state.single.height}ft ceilings → <strong>${Math.round(eff)} eq sq ft</strong>)
  </div>
`;


  condEl.textContent = "Single-zone system (handled by product selection below)";
  partsEl.innerHTML = `<div style="color:#666;font-size:13px;">Use “Add to cart” on Best/Budget Friendly to add the exact single-zone unit (plus accessories by line length).</div>`;

  // ✅ If over max coverage, show “no unit available” and disable add-to-cart
  const bestAddBtn = document.getElementById("bestAdd");
  const ezAddBtn = document.getElementById("ezAdd");

  if (!btu) {
    totalBtuEl.textContent = "—";
    totalKwEl.textContent = "—";

    document.getElementById("bestRec").textContent = "No unit available";
    document.getElementById("ezRec").textContent = "No unit available";

    const msg = `Max coverage is ${CONFIG.maxEffSqft} sq ft (effective). This room is ~${Math.round(eff)} eq sq ft.`;
    document.getElementById("bestMsg").textContent = msg;
    document.getElementById("ezMsg").textContent = msg;

    if (bestAddBtn) bestAddBtn.disabled = true;
    if (ezAddBtn) ezAddBtn.disabled = true;
    return;
  }

  // Normal sizing
totalBtuEl.textContent = Math.round(btu / 1000) + "k";
totalKwEl.textContent = btuToKw(btu);

const sizeLabel = Math.round(btu / 1000) + "k";

document.getElementById("bestRec").textContent = sizeLabel;

// EZPRO: block 36k explicitly
const ezIncompatible = (btu === 36000);
const ezRow = document.getElementById("ezRecRow");
const ezRec = document.getElementById("ezRec");

if (ezIncompatible) {
  // Remove "Recommended:" label entirely
  ezRow.innerHTML = `<span id="ezRec">Configuration not compatible</span>`;
} else {
  // Restore the original label + span
  ezRow.innerHTML = `Recommended: <span id="ezRec">${sizeLabel}</span>`;
}

// clear old error text if any
document.getElementById("bestMsg").textContent = "";

// Enable/disable buttons
setBtnDisabled(bestAddBtn, false);
setBtnDisabled(ezAddBtn, ezIncompatible);

return;
}


const m = computeMultiRoom();
totalBtuEl.textContent = Math.round(m.sumHeads / 1000) + "k";
totalKwEl.textContent = btuToKw(m.sumHeads);

roomSummaryEl.innerHTML = m.summaries.map(s => {
  if (s.overLimit) {
    return `
      <div style="margin:6px 0;font-size:13px;color:#b00020;">
        <strong>${s.label}</strong> — ${s.sf} sq ft, ${state.rooms[s.idx].height}ft ceilings → ${s.eff} eq sf —
        <strong>NO UNIT AVAILABLE</strong> (max ${CONFIG.maxEffSqft} eq sq ft)
      </div>
    `;
  }

  return `
    <div style="margin:6px 0;font-size:13px;color:#111;">
      <strong>${s.label}</strong> — ${s.sf} sq ft, ${state.rooms[s.idx].height}ft ceilings → ${s.eff} eq sf — suggested ${Math.round(s.suggested / 1000)}k
    </div>
  `;
}).join("");

if (m.hasOverLimitRoom) {
  // Block bundle add + show message
  condEl.textContent = `One or more rooms exceed max coverage (${CONFIG.maxEffSqft} effective sq ft).`;
  partsEl.innerHTML = `<div style="color:#b00020;font-size:13px;">
    Cannot build a multi-room bundle because at least one room is above the maximum supported coverage for the 36k unit.
    Reduce room size or ceiling height adjustment.
  </div>`;

  addBundleBtn.style.display = "block";
  addBundleBtn.disabled = true;
  return;
}

// Normal multi-room flow

const condBtu = chooseCondenserBtuByHeads(m.sumHeads);
const overTenPercent = isMoreThanTenPercentOver(m.sumHeads, condBtu);

condEl.textContent = `Condenser: ${Math.round(condBtu / 1000)}k multi-zone`;

partsEl.innerHTML = m.summaries.map(s => {
  const typeLabel = s.type === "cassette" ? "Ceiling cassette" : "Wall mount";
  const gauge = CONFIG.gaugeKeyByBtu[s.chosen] || "";
  return `<div style="margin:6px 0;font-size:13px;color:#111;">
    • ${typeLabel} <strong>${Math.round(s.chosen / 1000)}k</strong> + line set <strong>${s.lineLen} ft</strong> ${gauge ? `(${gauge})` : ""}
  </div>`;
}).join("");

addBundleBtn.style.display = "block";

if (overTenPercent && condBtu === 55000) {
  condEl.innerHTML += `
    <div style="margin-top:8px;color:#b00020;font-weight:600;">
      You're more than 10% over this condenser's capacity.
      This is not recommended. Would you still like to proceed?
    </div>
  `;

  addBundleBtn.textContent = "Proceed Anyway";
  addBundleBtn.style.background = "#b00020";
  addBundleBtn.disabled = false;

} else {
  addBundleBtn.textContent = "Add Full Bundle To Cart";
  addBundleBtn.style.background = "#2f0360";
  addBundleBtn.disabled = false;
}

}

async function populateSingleLineLengths() {
  const bestLens = [16, 25, 50, 66, 75];
  const ezLens = [16, 32, 41, 51, 66];

  const bestSel = document.getElementById("bestLen");
  const ezSel = document.getElementById("ezLen");

  bestSel.innerHTML = bestLens.map(x => `<option value="${x}">${x} ft</option>`).join("");
  ezSel.innerHTML = ezLens.map(x => `<option value="${x}">${x} ft</option>`).join("");

  bestSel.value = String(state.single.bestLineLen);
  ezSel.value = String(state.single.ezLineLen);
}
function getEzproIncludedLen() {
  return 16;
}

function getEzproExtensionLen(totalLen) {
  const included = getEzproIncludedLen();
  const ext = Number(totalLen) - included;
  return ext > 0 ? ext : 0;
}

function pickEzproExt16HandleByBtu(btu) {
  if (btu <= 12000) return CONFIG.handles.easyProLineset16Small;   // 9k/12k
  if (btu === 18000) return CONFIG.handles.easyProLineset16Medium; // 18k
  return CONFIG.handles.easyProLineset16Large;                     // 24k/36k
}
async function buildBestAccessoryItems(btu, desiredTotalLen) {
  const items = [];
  const L = Number(desiredTotalLen);

  // 5th Gen includes 25ft. Add-ons depend on TOTAL selected.
  const addOnMap = {
    16: [16], 
    25: [],
    50: [50],
    66: [16, 50],
    75: [50],
  };

  const addOns = addOnMap[L];

  if (!addOns) {
    throw new Error(`Unsupported 5th Gen line length: ${L} ft`);
  }

  for (const ft of addOns) {
    const v = await resolveLineSetVariant(btu, ft);
    items.push({ id: v.id, quantity: 1 });
  }

  // coupler rule (only for 66 and 75)
  if (L === 66 || L === 75) {
    const coupler = await resolveCoupler75Variant(btu);
    items.push({ id: coupler.id, quantity: 1 });
  }

  return items;
}

async function resolveSingleVariantFromHandle(handle) {
  if (!handle) throw new Error("Missing product handle for EZPRO accessory.");
  const product = await fetchProduct(handle);
  const vars = product?.variants || [];
  if (!vars.length) throw new Error(`No variants found for accessory product: ${handle}`);
  return vars[0]; // these are typically single-variant products
}

/**
 * EZPRO ACCESSORIES RULES (Single-zone):
 * - All units include 16ft.
 * - If desired total length is 32/41/51/66:
 *    extension length = total - 16 => 16/25/35/50
 *    add that extension product + add coupler product
 */
async function buildEzproAccessoryItems(btu, desiredTotalLen) {
  const items = [];
  const extLen = getEzproExtensionLen(desiredTotalLen);

  // no accessories if user selects 16
  if (!extLen) return items;

  if (extLen === 16) {
    const ext16Handle = pickEzproExt16HandleByBtu(btu);
    const v = await resolveSingleVariantFromHandle(ext16Handle);
    items.push({ id: v.id, quantity: 1 });
  } else if ([25, 35, 50].includes(extLen)) {
    const v = await resolveLineSetVariant(btu, extLen);
    items.push({ id: v.id, quantity: 1 });
  } else {
    throw new Error(`Unsupported EZPRO length: ${desiredTotalLen}ft (needs extension ${extLen}ft).`);
  }

  // 2) Always add the coupler product 
  const coupler = await resolveCoupler75Variant(btu);
  items.push({ id: coupler.id, quantity: 1 });

  return items;
}

async function addSingleToCart(series) {
  const msgEl = series === "best" ? document.getElementById("bestMsg") : document.getElementById("ezMsg");
  msgEl.textContent = "Adding to cart…";

  try {
    
    const handle = series === "best" ? CONFIG.handles.singleBest : CONFIG.handles.singleEzpro;
    const product = await fetchProduct(handle);

    const btu = computeSingleSizing();


if (series === "ez" && btu === 36000) {
  msgEl.textContent = "Configuration not compatible.";
  return;
}
    
    const eff = effectiveSqft(state.single.len, state.single.wid, state.single.height);
    if (!btu) {
      throw new Error(`No unit available above ${CONFIG.maxEffSqft} sq ft coverage. This room is ~${Math.round(eff)} eq sq ft.`);
    }

    const sizeText = `${Math.round(btu / 1000)}k`;

    const selectedLen =
      series === "best"
        ? Number(document.getElementById("bestLen").value)
        : Number(document.getElementById("ezLen").value);

    // Resolve system variant by SIZE ONLY
    const variants = product?.variants || [];
    const systemVariant =
      variants.find(v => (v.title || "").toLowerCase().includes(sizeText.toLowerCase())) ||
      findVariantByTexts(product, [sizeText]);

    if (!systemVariant) {
      throw new Error(`No 36k model available for this product.`);
    }

    const items = [{ id: systemVariant.id, quantity: 1 }];

    if (series === "best") {
  // ---- BEST logic (25ft included) ----
  const accessoryItems = await buildBestAccessoryItems(btu, selectedLen);
  items.push(...accessoryItems);
} else {
  // ---- EZPRO logic (UNCHANGED) ----
  const accessoryItems = await buildEzproAccessoryItems(btu, selectedLen);
  items.push(...accessoryItems);
}

    await addToCart(items);

    msgEl.innerHTML = `Added to cart. <a href="/cart" style="color:#1565c0;">View cart</a>`;
  } catch (e) {
    console.error(e);
    msgEl.textContent = e.message || "Failed to add.";
  }
}




function normalizeTypeText(type) {
  return type === "cassette" ? ["cassette", "ceiling"] : ["wall", "wall mount", "wall-mounted"];
}

async function resolveAhuVariant(type, btu) {
  const handle = type === "cassette" ? CONFIG.handles.cassetteAhu : CONFIG.handles.wallAhu;
  if (!handle) throw new Error(`Missing ${type} AHU product handle in section settings.`);

  const product = await fetchProduct(handle);
  const sizeText = `${Math.round(btu / 1000)}k`;
  const vars = product.variants || [];

  // Match by size only (since type is implied by which product we fetched)
  const v =
    vars.find(v => (v.title || "").toLowerCase().includes(sizeText)) ||
    findVariantByTexts(product, [sizeText]);

  if (!v) throw new Error(`AHU variant not found for ${type} ${sizeText} in product: ${handle}`);
  return v;
}


async function resolveLineSetVariant(btu, lineLenFt) {
  const gauge = CONFIG.gaugeKeyByBtu[btu];
  const handle = CONFIG.handles.lineSetsByGauge[gauge];

  if (!handle) throw new Error(`Missing line set handle for gauge ${gauge} (btu ${btu}).`);

  const product = await fetchProduct(handle);
  const wantedLen = Number(lineLenFt);
  const vars = product.variants || [];

  // Prefer exact extracted ft match, fallback to "includes"
  const exact = vars.find(v => extractFtFromTitle(v.title) === wantedLen);
  if (exact) return exact;

  const fuzzy = vars.find(v => (v.title || "").toLowerCase().includes(String(wantedLen)));
  if (fuzzy) return fuzzy;

  throw new Error(`Line set variant not found for ${wantedLen}ft in product: ${handle}`);
}


async function resolveCondenserVariant(condBtu) {
  const product = await fetchProduct(CONFIG.handles.multiCondenser);
  const btuText = `${Math.round(condBtu / 1000)}k`;

  const vars = product.variants || [];

  // Ignore "zone" entirely; match on btu only
  const v =
    vars.find(v => (v.title || "").toLowerCase().includes(btuText)) ||
    findVariantByTexts(product, [btuText]);

  if (!v) throw new Error(`Condenser variant not found for ${btuText} in product: ${CONFIG.handles.multiCondenser}`);
  return v;
}

function pickCoupler75HandleByBtu(btu) {
  // 6k/9k/12k/18k => “small” coupler product
  if (btu <= 18000) return CONFIG.handles.coupler75Small;

  // 24k/36k => “large” coupler product
  return CONFIG.handles.coupler75Large;
}

async function resolveCoupler75Variant(btu) {
  const handle = pickCoupler75HandleByBtu(btu);
  if (!handle) throw new Error("Missing coupler handle (set data-coupler-small / data-coupler-large).");

  const product = await fetchProduct(handle);

  const vars = product?.variants || [];
  if (vars.length === 1) return vars[0];

  const sizeText = `${Math.round(btu / 1000)}k`;

  // Try to match by size if present in variant title/options
  const v =
    vars.find(v => (v.title || "").toLowerCase().includes(sizeText.toLowerCase())) ||
    findVariantByTexts(product, [sizeText]);

  return v || vars[0]; // fallback to first variant
}

async function addBundleToCart() {
  const msg = document.getElementById("bundleMsg");
  msg.textContent = "Building bundle…";

  try {
    const m = computeMultiRoom();
    if (m.hasOverLimitRoom) {
      throw new Error(`Cannot build bundle: at least one room exceeds ${CONFIG.maxEffSqft} effective sq ft (36k max).`);
    }
    const condBtu = chooseCondenserBtuByHeads(m.sumHeads);

    // Build items list: condenser x1 + each room’s AHU + line set
    const items = [];

const condenser = await resolveCondenserVariant(condBtu);
items.push({ id: condenser.id, quantity: 1 });

   for (const s of m.summaries) {
  const ahu = await resolveAhuVariant(s.type, s.chosen);
  items.push({ id: ahu.id, quantity: 1 });

// Always add selected line set (INCLUDING 75)
const line = await resolveLineSetVariant(s.chosen, s.lineLen);
items.push({ id: line.id, quantity: 1 });

// If 75ft, ALSO add coupler
if (Number(s.lineLen) === 75) {
  const coupler = await resolveCoupler75Variant(s.chosen);
  items.push({ id: coupler.id, quantity: 1 });
}


}

    await addToCart(items);
    msg.innerHTML = `Added bundle to cart. <a href="/cart" style="color:#1565c0;">View cart</a>`;
  } catch (e) {
    console.error(e);
    msg.textContent = e.message || "Failed to add bundle.";
  }
}

// ---------- Wiring ----------
function setMode(mode) {
  state.mode = mode;
  document.getElementById("singleUI").style.display = mode === "single" ? "block" : "none";
  document.getElementById("multiUI").style.display  = mode === "multi"  ? "block" : "none";
  document.getElementById("capWrap").style.display  = mode === "multi"  ? "flex"  : "none";
  if (singleCards) singleCards.style.display = (mode === "single") ? "" : "none";

  render();
}

function render() {
  if (state.mode === "multi") {
    // Enforce cap
    state.rooms = state.rooms.slice(0, state.cap);
    if (state.rooms.length === 0) state.rooms.push({ label:"Room 1", len:12, wid:12, height:8, type:"wall", size:null, lineLen:CONFIG.defaultLineLen });
    renderRooms();
  }
  renderResults();
  bindRoomEvents();
}

function bindRoomEvents() {
  if (state.mode !== "multi") return;

  document.querySelectorAll("[data-remove]").forEach(btn => {
    btn.addEventListener("click", () => {
      const idx = Number(btn.getAttribute("data-remove"));
      state.rooms.splice(idx, 1);
      // relabel
      state.rooms.forEach((r, i) => r.label = `Room ${i+1}`);
      render();
    });
  });

  document.querySelectorAll("[data-room][data-k]").forEach(inp => {
    inp.addEventListener("input", () => {
      const idx = Number(inp.getAttribute("data-room"));
      const k = inp.getAttribute("data-k");
      const v = inp.value;

      if (k === "len" || k === "wid" || k === "height" || k === "lineLen" || k === "size") {
  state.rooms[idx][k] = Number(v);
} else {
  state.rooms[idx][k] = v;

  // If switching to cassette, force invalid sizes down to allowed max
  if (k === "type") {
    state.rooms[idx].size = normalizeHeadSizeForType(state.rooms[idx].type, state.rooms[idx].size || 18000);
  }
}

      renderResults();
      // keep parts list updated without re-rendering whole cards every keystroke
    });
    inp.addEventListener("change", () => render());
  });
}

function installCartDrawerDelegates() {
  if (window.__BTU_CART_DELEGATES_INSTALLED__) return;
  window.__BTU_CART_DELEGATES_INSTALLED__ = true;

  document.addEventListener("click", async (e) => {
    const t = e.target;

    // ---- CLOSE: main X or overlay
    const closeBtn =
      t.closest('button[aria-label="Close"]') ||
      t.closest('button[aria-label="close"]') ||
      t.closest(".drawer__close") ||
      t.closest(".cart-drawer__close") ||
      t.closest('button[id*="CartDrawer-Overlay"]') ||
      t.closest(".fixed-overlay");

    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      closeCartDrawer();
      return;
    }

    // ---- REMOVE line item
    const removeHost =
      t.closest("cart-remove-button") ||
      t.closest(".cart-item__remove") ||
      t.closest('[data-cart-remove]') ||
      t.closest('a[href*="cart/change"]') ||
      t.closest('button[name="remove"]');

    if (removeHost && removeHost.closest("cart-drawer, #CartDrawer, .drawer--cart")) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const lineAttr =
        removeHost.getAttribute("data-index") ||
        removeHost.dataset.index ||
        removeHost.getAttribute("data-line") ||
        removeHost.dataset.line;

      const line = Number(lineAttr);
      if (!Number.isFinite(line) || line <= 0) {
        console.warn("Could not determine cart line index for remove");
        return;
      }

      try {
        await cartChangeLine(line, 0);
        await openAndRefreshCartDrawer();
      } catch (err) {
        console.error(err);
      }
      return;
    }

    // ---- QTY +/-
    const qtyBtn = t.closest('button[name="plus"], button[name="minus"], button[data-quantity-button]');
    if (qtyBtn && qtyBtn.closest("cart-drawer, #CartDrawer, .drawer--cart")) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const lineItem =
        qtyBtn.closest("[data-index]") ||
        qtyBtn.closest(".cart-item") ||
        qtyBtn.closest("tr") ||
        qtyBtn.closest("li");

      if (!lineItem) return;

      const input = lineItem.querySelector('input[name="updates[]"], input[type="number"]');
      if (!input) return;

      const lineAttr =
        input.getAttribute("data-index") ||
        lineItem.getAttribute("data-index") ||
        lineItem.dataset?.index;

      const line = Number(lineAttr);
      const currentQty = Number(input.value);

      if (!Number.isFinite(line) || !Number.isFinite(currentQty)) return;

      const isMinus =
        qtyBtn.name === "minus" ||
        qtyBtn.getAttribute("data-quantity-button") === "minus";

      const nextQty = isMinus ? Math.max(0, currentQty - 1) : currentQty + 1;

      try {
        await cartChangeLine(line, nextQty);
        await openAndRefreshCartDrawer();
      } catch (err) {
        console.error(err);
      }

      return;
    }
  }, true);
}


// Init
(function init() {
  installCartDrawerDelegates();
  // Mode
  document.getElementById("mode").addEventListener("change", (e) => setMode(e.target.value));
  document.getElementById("cap").addEventListener("change", (e) => {
    state.cap = Number(e.target.value);
    render();
  });

  // Single room bindings
  const bindSingle = (id, key) => {
    document.getElementById(id).addEventListener("input", (e) => {
      state.single[key] = Number(e.target.value);
      renderResults();
    });
  };
  bindSingle("sLen","len");
  bindSingle("sWid","wid");
  bindSingle("sHei","height");

  document.getElementById("bestLen").addEventListener("change", (e)=> state.single.bestLineLen = Number(e.target.value));
  document.getElementById("ezLen").addEventListener("change", (e)=> state.single.ezLineLen = Number(e.target.value));

  document.getElementById("bestAdd").addEventListener("click", ()=> addSingleToCart("best"));
  document.getElementById("ezAdd").addEventListener("click", ()=> addSingleToCart("ez"));

  // Multi room buttons
  document.getElementById("addRoom").addEventListener("click", () => {
    if (state.rooms.length >= Math.min(state.cap, 6)) return;
    state.rooms.push({ label:`Room ${state.rooms.length+1}`, len:12, wid:12, height:8, type:"wall", size:null, lineLen:CONFIG.defaultLineLen });
    render();
  });

  document.getElementById("reset").addEventListener("click", () => {
    state.rooms = [
      { label:"Room 1", len:12, wid:12, height:8, type:"wall", size:null, lineLen:CONFIG.defaultLineLen },
      { label:"Room 2", len:12, wid:15, height:8, type:"wall", size:null, lineLen:CONFIG.defaultLineLen }
    ];
    render();
  });

  document.getElementById("addBundle").addEventListener("click", addBundleToCart);

  populateSingleLineLengths();
  setMode("single");
})();

})();
